import { SearchType } from '@brightdrop/bd-ui';
import type { SearchCriteria } from '~/common/models/common.model';
import {
  DiagnosticState,
  FleetMapFilterType,
  type FleetMapList,
  FleetMapSessionViewType,
  type FleetMapState,
  FuelChargeLevel,
  type MapFilterCriteria,
  VehicleStatus,
} from '~/common/models/fleetMap.model';

export const FLEET_MAP_SEARCH_CRITERIA_DEFAULT_STATE: SearchCriteria = {
  searchType: SearchType.COMBINED_VEHICLE_SEARCH,
  input: '',
};

export const FLEET_MAP_FILTER_EMPTY_STATE: MapFilterCriteria = {
  [FleetMapFilterType.STATUS]: [],
  [FleetMapFilterType.DIAGNOSTIC]: [],
  [FleetMapFilterType.FUEL_OR_CHARGE]: [],
};

export const FLEET_MAP_LIST_EMPTY_STATE: FleetMapList = {};

export const INITIAL_FLEET_MAP_STATE: FleetMapState = {
  [FleetMapSessionViewType.FLEET_MAP_LIST]: FLEET_MAP_LIST_EMPTY_STATE,
  [FleetMapSessionViewType.FLEET_MAP_FILTERS]: {
    searchCriteria: FLEET_MAP_SEARCH_CRITERIA_DEFAULT_STATE,
    filterType: FLEET_MAP_FILTER_EMPTY_STATE,
  },
  [FleetMapSessionViewType.VEHICLE_INTERACTION]: {
    selectedVehicle: null,
    hoveredVehicle: null,
    vehicleDetails: null,
    centerOnFleet: false,
  },
};

export const FLEET_MAP_FILTERS = [
  {
    title: 'Status',
    id: 'status',
    type: FleetMapFilterType.STATUS,
    options: [
      { label: 'Moving', value: VehicleStatus.MOVING },
      { label: 'Parked', value: VehicleStatus.PARKED },
      { label: 'Idling', value: VehicleStatus.IDLING },
      { label: 'Offline', value: VehicleStatus.OFFLINE },
    ],
  },
  {
    title: 'Diagnostic',
    id: 'diagnostic',
    type: FleetMapFilterType.DIAGNOSTIC,
    options: [
      { label: 'Critical', value: DiagnosticState.CRITICAL },
      { label: 'Warning', value: DiagnosticState.WARNING },
      { label: 'OK', value: DiagnosticState.OK },
    ],
  },
  {
    title: 'Fuel or Charge',
    id: 'fuel-or-charge',
    type: FleetMapFilterType.FUEL_OR_CHARGE,
    options: [
      { label: '20% or less', value: FuelChargeLevel.TWENTY_PERCENT_OR_LESS },
      { label: '21% - 50%', value: FuelChargeLevel.TWENTY_ONE_TO_FIFTY },
      { label: '51% - 80%', value: FuelChargeLevel.FIFTY_ONE_TO_EIGHTY },
      { label: '81% or more', value: FuelChargeLevel.EIGHTY_ONE_OR_MORE },
    ],
  },
];
